export enum DiagnosticReportValidationTypes {
    dermaCscV1AddDraftDiagnosticReport = 'dermaCscV1AddDraftDiagnosticReport',
    dermaCscV1AddFinalDiagnosticReport = 'dermaCscV1AddFinalDiagnosticReport',
    dermaCscV1EditDraftDiagnosticReport = 'dermaCscV1EditDraftDiagnosticReport',
    dermaCscV1EditFinalDiagnosticReport = 'dermaCscV1EditFinalDiagnosticReport',
    dermaCV1AddDraftDiagnosticReport = 'dermaCV1AddDraftDiagnosticReport',
    dermaCV1AddFinalDiagnosticReport = 'dermaCV1AddFinalDiagnosticReport',
    dermaCV1EditDraftDiagnosticReport = 'dermaCV1EditDraftDiagnosticReport',
    dermaCV1EditFinalDiagnosticReport = 'dermaCV1EditFinalDiagnosticReport',
    dermaCwondV1AddDraftDiagnosticReport = 'dermaCwondV1AddDraftDiagnosticReport',
    dermaCwondV1AddFinalDiagnosticReport = 'dermaCwondV1AddFinalDiagnosticReport',
    dermaCwondV1EditDraftDiagnosticReport = 'dermaCwondV1EditDraftDiagnosticReport',
    dermaCwondV1EditFinalDiagnosticReport = 'dermaCwondV1EditFinalDiagnosticReport',
    dermaOthV1AddDraftDiagnosticReport = 'dermaOthV1AddDraftDiagnosticReport',
    dermaOthV1AddFinalDiagnosticReport = 'dermaOthV1AddFinalDiagnosticReport',
    dermaOthV1EditDraftDiagnosticReport = 'dermaOthV1EditDraftDiagnosticReport',
    dermaOthV1EditFinalDiagnosticReport = 'dermaOthV1EditFinalDiagnosticReport',
    dermaSnelCscV1AddDraftDiagnosticReport = 'dermaSnelCscV1AddDraftDiagnosticReport',
    dermaSnelCscV1AddFinalDiagnosticReport = 'dermaSnelCscV1AddFinalDiagnosticReport',
    dermaSnelCscV1EditDraftDiagnosticReport = 'dermaSnelCscV1EditDraftDiagnosticReport',
    dermaSnelCscV1EditFinalDiagnosticReport = 'dermaSnelCscV1EditFinalDiagnosticReport',
    dermaSnelCV1AddDraftDiagnosticReport = 'dermaSnelCV1AddDraftDiagnosticReport',
    dermaSnelCV1AddFinalDiagnosticReport = 'dermaSnelCV1AddFinalDiagnosticReport',
    dermaSnelCV1EditDraftDiagnosticReport = 'dermaSnelCV1EditDraftDiagnosticReport',
    dermaSnelCV1EditFinalDiagnosticReport = 'dermaSnelCV1EditFinalDiagnosticReport',
    ggzcf2fV1AddDraftDiagnosticReport = 'ggzcf2fV1AddDraftDiagnosticReport',
    ggzcf2fV1AddFinalDiagnosticReport = 'ggzcf2fV1AddFinalDiagnosticReport',
    ggzcf2fV1EditDraftDiagnosticReport = 'ggzcf2fV1EditDraftDiagnosticReport',
    ggzcf2fV1EditFinalDiagnosticReport = 'ggzcf2fV1EditFinalDiagnosticReport',
    ggzcgV1AddDraftDiagnosticReport = 'ggzcgV1AddDraftDiagnosticReport',
    ggzcgV1AddFinalDiagnosticReport = 'ggzcgV1AddFinalDiagnosticReport',
    ggzcgV1EditDraftDiagnosticReport = 'ggzcgV1EditDraftDiagnosticReport',
    ggzcgV1EditFinalDiagnosticReport = 'ggzcgV1EditFinalDiagnosticReport',
    ggzcmdoV1AddDraftDiagnosticReport = 'ggzcmdoV1AddDraftDiagnosticReport',
    ggzcmdoV1AddFinalDiagnosticReport = 'ggzcmdoV1AddFinalDiagnosticReport',
    ggzcmdoV1EditDraftDiagnosticReport = 'ggzcmdoV1EditDraftDiagnosticReport',
    ggzcmdoV1EditFinalDiagnosticReport = 'ggzcmdoV1EditFinalDiagnosticReport',
    ggzctriageV1AddDraftDiagnosticReport = 'ggzctriageV1AddDraftDiagnosticReport',
    ggzctriageV1AddFinalDiagnosticReport = 'ggzctriageV1AddFinalDiagnosticReport',
    ggzctriageV1EditDraftDiagnosticReport = 'ggzctriageV1EditDraftDiagnosticReport',
    ggzctriageV1EditFinalDiagnosticReport = 'ggzctriageV1EditFinalDiagnosticReport',
    ggzctV1AddDraftDiagnosticReport = 'ggzctV1AddDraftDiagnosticReport',
    ggzctV1AddFinalDiagnosticReport = 'ggzctV1AddFinalDiagnosticReport',
    ggzctV1EditDraftDiagnosticReport = 'ggzctV1EditDraftDiagnosticReport',
    ggzctV1EditFinalDiagnosticReport = 'ggzctV1EditFinalDiagnosticReport',
    ggzV1AddDischargeDiagnosticReport = 'ggzV1AddDischargeDiagnosticReport',
    ggzV1AddIntakeDiagnosticReport = 'ggzV1AddIntakeDiagnosticReport',
    ggzV1EditDischargeDiagnosticReport = 'ggzV1EditDischargeDiagnosticReport',
    ggzV1EditIntakeDiagnosticReport = 'ggzV1EditIntakeDiagnosticReport',
    gtcV1AddDraftDiagnosticReport = 'gtcV1AddDraftDiagnosticReport',
    gtcV1AddFinalDiagnosticReport = 'gtcV1AddFinalDiagnosticReport',
    gtcV1EditDraftDiagnosticReport = 'gtcV1EditDraftDiagnosticReport',
    gtcV1EditFinalDiagnosticReport = 'gtcV1EditFinalDiagnosticReport',
    gtoV1AddDraftDiagnosticReport = 'gtoV1AddDraftDiagnosticReport',
    gtoV1AddFinalDiagnosticReport = 'gtoV1AddFinalDiagnosticReport',
    gtoV1EditDraftDiagnosticReport = 'gtoV1EditDraftDiagnosticReport',
    gtoV1EditFinalDiagnosticReport = 'gtoV1EditFinalDiagnosticReport',
    ocrkV1AddDraftDiagnosticReport = 'ocrkV1AddDraftDiagnosticReport',
    ocrkV1AddFinalDiagnosticReport = 'ocrkV1AddFinalDiagnosticReport',
    ocrkV1EditDraftDiagnosticReport = 'ocrkV1EditDraftDiagnosticReport',
    ocrkV1EditFinalDiagnosticReport = 'ocrkV1EditFinalDiagnosticReport',
    oorkV1AddDraftDiagnosticReport = 'oorkV1AddDraftDiagnosticReport',
    oorkV1AddFinalDiagnosticReport = 'oorkV1AddFinalDiagnosticReport',
    oorkV1EditDraftDiagnosticReport = 'oorkV1EditDraftDiagnosticReport',
    oorkV1EditFinalDiagnosticReport = 'oorkV1EditFinalDiagnosticReport',
    orthCV1AddDraftDiagnosticReport = 'orthCV1AddDraftDiagnosticReport',
    orthCV1AddFinalDiagnosticReport = 'orthCV1AddFinalDiagnosticReport',
    orthCV1EditDraftDiagnosticReport = 'orthCV1EditDraftDiagnosticReport',
    orthCV1EditFinalDiagnosticReport = 'orthCV1EditFinalDiagnosticReport',
    orthOFolV1AddDraftDiagnosticReport = 'orthOFolV1AddDraftDiagnosticReport',
    orthOFolV1AddFinalDiagnosticReport = 'orthOFolV1AddFinalDiagnosticReport',
    orthOFolV1EditDraftDiagnosticReport = 'orthOFolV1EditDraftDiagnosticReport',
    orthOFolV1EditFinalDiagnosticReport = 'orthOFolV1EditFinalDiagnosticReport',
    orthOV1AddDraftDiagnosticReport = 'orthOV1AddDraftDiagnosticReport',
    orthOV1AddFinalDiagnosticReport = 'orthOV1AddFinalDiagnosticReport',
    orthOV1EditDraftDiagnosticReport = 'orthOV1EditDraftDiagnosticReport',
    orthOV1EditFinalDiagnosticReport = 'orthOV1EditFinalDiagnosticReport',
    osasc1V1AddDraftDiagnosticReport = 'osasc1V1AddDraftDiagnosticReport',
    osasc1V1AddFinalDiagnosticReport = 'osasc1V1AddFinalDiagnosticReport',
    osasc1V1EditDraftDiagnosticReport = 'osasc1V1EditDraftDiagnosticReport',
    osasc1V1EditFinalDiagnosticReport = 'osasc1V1EditFinalDiagnosticReport',
    osasc2V1AddDraftDiagnosticReport = 'osasc2V1AddDraftDiagnosticReport',
    osasc2V1AddFinalDiagnosticReport = 'osasc2V1AddFinalDiagnosticReport',
    osasc2V1EditDraftDiagnosticReport = 'osasc2V1EditDraftDiagnosticReport',
    osasc2V1EditFinalDiagnosticReport = 'osasc2V1EditFinalDiagnosticReport',
    osasc2V2AddDraftDiagnosticReport = 'osasc2V2AddDraftDiagnosticReport',
    osasc2V2AddFinalDiagnosticReport = 'osasc2V2AddFinalDiagnosticReport',
    osasc2V2EditDraftDiagnosticReport = 'osasc2V2EditDraftDiagnosticReport',
    osasc2V2EditFinalDiagnosticReport = 'osasc2V2EditFinalDiagnosticReport',
    osasoV1AddDraftDiagnosticReport = 'osasoV1AddDraftDiagnosticReport',
    osasoV1AddFinalDiagnosticReport = 'osasoV1AddFinalDiagnosticReport',
    osasoV1EditDraftDiagnosticReport = 'osasoV1EditDraftDiagnosticReport',
    osasoV1EditFinalDiagnosticReport = 'osasoV1EditFinalDiagnosticReport',
    osasqV1AddDraftDiagnosticReport = 'osasqV1AddDraftDiagnosticReport',
    osasqV1AddFinalDiagnosticReport = 'osasqV1AddFinalDiagnosticReport',
    osasqV1EditDraftDiagnosticReport = 'osasqV1EditDraftDiagnosticReport',
    osasqV1EditFinalDiagnosticReport = 'osasqV1EditFinalDiagnosticReport',
    osasvoV1AddDraftDiagnosticReport = 'osasvoV1AddDraftDiagnosticReport',
    osasvoV1AddFinalDiagnosticReport = 'osasvoV1AddFinalDiagnosticReport',
    osasvoV1EditDraftDiagnosticReport = 'osasvoV1EditDraftDiagnosticReport',
    osasvoV1EditFinalDiagnosticReport = 'osasvoV1EditFinalDiagnosticReport',
    pilotConsultationV1AddDraftDiagnosticReport = 'pilotConsultationV1AddDraftDiagnosticReport',
    pilotConsultationV1AddFinalDiagnosticReport = 'pilotConsultationV1AddFinalDiagnosticReport',
    pilotConsultationV1EditDraftDiagnosticReport = 'pilotConsultationV1EditDraftDiagnosticReport',
    pilotConsultationV1EditFinalDiagnosticReport = 'pilotConsultationV1EditFinalDiagnosticReport',
    pilotExaminationV1AddDraftDiagnosticReport = 'pilotExaminationV1AddDraftDiagnosticReport',
    pilotExaminationV1AddDraftDiagnosticReportWithRequest = 'pilotExaminationV1AddDraftDiagnosticReportWithRequest',
    pilotExaminationV1AddFinalDiagnosticReport = 'pilotExaminationV1AddFinalDiagnosticReport',
    pilotExaminationV1AddFinalDiagnosticReportWithRequest = 'pilotExaminationV1AddFinalDiagnosticReportWithRequest',
    pilotExaminationV1EditDraftDiagnosticReport = 'pilotExaminationV1EditDraftDiagnosticReport',
    pilotExaminationV1EditFinalDiagnosticReport = 'pilotExaminationV1EditFinalDiagnosticReport',
    pilotReferralV1AddDraftDischargeDiagnosticReport = 'pilotReferralV1AddDraftDischargeDiagnosticReport',
    pilotReferralV1AddDraftIntakeDiagnosticReport = 'pilotReferralV1AddDraftIntakeDiagnosticReport',
    pilotReferralV1AddFinalDischargeDiagnosticReport = 'pilotReferralV1AddFinalDischargeDiagnosticReport',
    pilotReferralV1AddFinalIntakeDiagnosticReport = 'pilotReferralV1AddFinalIntakeDiagnosticReport',
    pilotReferralV1EditDraftDischargeDiagnosticReport = 'pilotReferralV1EditDraftDischargeDiagnosticReport',
    pilotReferralV1EditDraftIntakeDiagnosticReport = 'pilotReferralV1EditDraftIntakeDiagnosticReport',
    pilotReferralV1EditFinalDischargeDiagnosticReport = 'pilotReferralV1EditFinalDischargeDiagnosticReport',
    pilotReferralV1EditFinalIntakeDiagnosticReport = 'pilotReferralV1EditFinalIntakeDiagnosticReport',
    tcchV1AddDraftDiagnosticReport = 'tcchV1AddDraftDiagnosticReport',
    tcchV1AddFinalDiagnosticReport = 'tcchV1AddFinalDiagnosticReport',
    tcchV1EditDraftDiagnosticReport = 'tcchV1EditDraftDiagnosticReport',
    tcchV1EditFinalDiagnosticReport = 'tcchV1EditFinalDiagnosticReport',
    tcciV1AddDraftDiagnosticReport = 'tcciV1AddDraftDiagnosticReport',
    tcciV1AddFinalDiagnosticReport = 'tcciV1AddFinalDiagnosticReport',
    tcciV1EditDraftDiagnosticReport = 'tcciV1EditDraftDiagnosticReport',
    tcciV1EditFinalDiagnosticReport = 'tcciV1EditFinalDiagnosticReport',
    tccrV1AddDraftDiagnosticReport = 'tccrV1AddDraftDiagnosticReport',
    tccrV1AddFinalDiagnosticReport = 'tccrV1AddFinalDiagnosticReport',
    tccrV1EditDraftDiagnosticReport = 'tccrV1EditDraftDiagnosticReport',
    tccrV1EditFinalDiagnosticReport = 'tccrV1EditFinalDiagnosticReport',
    tcohV1AddDraftDiagnosticReport = 'tcohV1AddDraftDiagnosticReport',
    tcohV1AddFinalDiagnosticReport = 'tcohV1AddFinalDiagnosticReport',
    tcohV1EditDraftDiagnosticReport = 'tcohV1EditDraftDiagnosticReport',
    tcohV1EditFinalDiagnosticReport = 'tcohV1EditFinalDiagnosticReport',
    tcohV2AddDraftDiagnosticReport = 'tcohV2AddDraftDiagnosticReport',
    tcohV2AddFinalDiagnosticReport = 'tcohV2AddFinalDiagnosticReport',
    tcohV2EditDraftDiagnosticReport = 'tcohV2EditDraftDiagnosticReport',
    tcohV2EditFinalDiagnosticReport = 'tcohV2EditFinalDiagnosticReport',
    tcorV1AddDraftDiagnosticReport = 'tcorV1AddDraftDiagnosticReport',
    tcorV1AddDraftDiagnosticReportWithRequest = 'tcorV1AddDraftDiagnosticReportWithRequest',
    tcorV1AddFinalDiagnosticReport = 'tcorV1AddFinalDiagnosticReport',
    tcorV1AddFinalDiagnosticReportWithRequest = 'tcorV1AddFinalDiagnosticReportWithRequest',
    tcorV1EditDraftDiagnosticReport = 'tcorV1EditDraftDiagnosticReport',
    tcorV1EditFinalDiagnosticReport = 'tcorV1EditFinalDiagnosticReport',
    tfcV1AddDraftDiagnosticReport = 'tfcV1AddDraftDiagnosticReport',
    tfcV1AddFinalDiagnosticReport = 'tfcV1AddFinalDiagnosticReport',
    tfcV1EditDraftDiagnosticReport = 'tfcV1EditDraftDiagnosticReport',
    tfcV1EditFinalDiagnosticReport = 'tfcV1EditFinalDiagnosticReport',
    tfoV1AddDraftDiagnosticReport = 'tfoV1AddDraftDiagnosticReport',
    tfoV1AddDraftDiagnosticReportWithRequest = 'tfoV1AddDraftDiagnosticReportWithRequest',
    tfoV1AddFinalDiagnosticReport = 'tfoV1AddFinalDiagnosticReport',
    tfoV1AddFinalDiagnosticReportWithRequest = 'tfoV1AddFinalDiagnosticReportWithRequest',
    tfoV1EditDraftDiagnosticReport = 'tfoV1EditDraftDiagnosticReport',
    tfoV1EditFinalDiagnosticReport = 'tfoV1EditFinalDiagnosticReport',
    tiecgV1AddDraftDiagnosticReport = 'tiecgV1AddDraftDiagnosticReport',
    tiecgV1AddDraftDiagnosticReportWithRequest = 'tiecgV1AddDraftDiagnosticReportWithRequest',
    tiecgV1AddFinalDiagnosticReport = 'tiecgV1AddFinalDiagnosticReport',
    tiecgV1AddFinalDiagnosticReportWithRequest = 'tiecgV1AddFinalDiagnosticReportWithRequest',
    tiecgV1EditDraftDiagnosticReport = 'tiecgV1EditDraftDiagnosticReport',
    tiecgV1EditFinalDiagnosticReport = 'tiecgV1EditFinalDiagnosticReport',
    tocV1AddDraftDiagnosticReport = 'tocV1AddDraftDiagnosticReport',
    tocV1AddFinalDiagnosticReport = 'tocV1AddFinalDiagnosticReport',
    tocV1EditDraftDiagnosticReport = 'tocV1EditDraftDiagnosticReport',
    tocV1EditFinalDiagnosticReport = 'tocV1EditFinalDiagnosticReport',
    tooV1AddDraftDiagnosticReport = 'tooV1AddDraftDiagnosticReport',
    tooV1AddDraftDiagnosticReportWithRequest = 'tooV1AddDraftDiagnosticReportWithRequest',
    tooV1AddFinalDiagnosticReport = 'tooV1AddFinalDiagnosticReport',
    tooV1AddFinalDiagnosticReportWithRequest = 'tooV1AddFinalDiagnosticReportWithRequest',
    tooV1EditDraftDiagnosticReport = 'tooV1EditDraftDiagnosticReport',
    tooV1EditFinalDiagnosticReport = 'tooV1EditFinalDiagnosticReport',
    tovV1AddDischargeDiagnosticReport = 'tovV1AddDischargeDiagnosticReport',
    tovV1AddIntakeDiagnosticReport = 'tovV1AddIntakeDiagnosticReport',
    tovV1EditDischargeDiagnosticReport = 'tovV1EditDischargeDiagnosticReport',
    tovV1EditIntakeDiagnosticReport = 'tovV1EditIntakeDiagnosticReport',
    tpcV1AddDraftDiagnosticReport = 'tpcV1AddDraftDiagnosticReport',
    tpcV1AddFinalDiagnosticReport = 'tpcV1AddFinalDiagnosticReport',
    tpcV1EditDraftDiagnosticReport = 'tpcV1EditDraftDiagnosticReport',
    tpcV1EditFinalDiagnosticReport = 'tpcV1EditFinalDiagnosticReport',
    tpoV1AddDraftDiagnosticReport = 'tpoV1AddDraftDiagnosticReport',
    tpoV1AddDraftDiagnosticReportWithRequest = 'tpoV1AddDraftDiagnosticReportWithRequest',
    tpoV1AddFinalDiagnosticReport = 'tpoV1AddFinalDiagnosticReport',
    tpoV1AddFinalDiagnosticReportWithRequest = 'tpoV1AddFinalDiagnosticReportWithRequest',
    tpoV1EditDraftDiagnosticReport = 'tpoV1EditDraftDiagnosticReport',
    tpoV1EditFinalDiagnosticReport = 'tpoV1EditFinalDiagnosticReport',
}
